import { Routes } from '@angular/router';
import { FleetsPage } from './fleets.page';
import { v2On } from '../v2/ui-v2.guard';


export const fleetsRoutes: Routes = [
    {
        path: 'fleets',
        component: FleetsPage,
        children: [
            {
                path: '',
                redirectTo: 'list',
                pathMatch: 'full'
            },
            {
                path: 'add',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/fleets/add-fleet-v2.page').then( m => m.AddFleetV2Page)
            },
            {
                path: 'add',
                loadComponent: () => import('./add-fleet/add-fleet.page').then( m => m.AddFleetPage)
            },
            {
                path: 'list',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/fleets/list-fleets-v2.page').then( m => m.ListFleetsV2Page)
            },
            {
                path: 'details',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/fleets/fleet-detail-v2.page').then( m => m.FleetDetailV2Page)
            },
            {
                path: 'list',
                loadComponent: () => import('./list-fleets/list-fleets.page').then( m => m.ListFleetsPage)
            },
        ]
    },
    // {
    //     path: 'tabs/trip-detail',
    //     loadComponent: () => import('./trip-detail/trip-detail.page').then( m => m.TripDetailPage)
    // },
    
];